import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.string.trim.js";
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "voucher-code-input-wrap"
};
import { ref } from "vue";
import Button from "../base/Button.vue";
import Input from "../base/Input.vue";
import { hideLoading, showLoading } from "@/utils/loadingUtil";
import { getVoucherCodeDetail } from "@/api/user";
import { getSupplyId } from "@/utils/authUtil";
import { Notify } from "@/utils/notifyUtil";
import { useI18n } from "vue-i18n";
export default {
  __name: 'VoucherCodeVerify',
  props: {
    isNotNeed: {
      type: Boolean,
      default: false
    }
  },
  emits: ["verify"],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var props = __props;
    var emits = __emit;
    var inputVal = ref("");
    var errorText = ref("");
    function handleVerify() {
      return _handleVerify.apply(this, arguments);
    }
    function _handleVerify() {
      _handleVerify = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _inputVal$value, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              errorText.value = "";
              if (!props.isNotNeed) {
                _context.next = 4;
                break;
              }
              Notify.warn(t("pointsAndVoucherCodeCannotUseTogether"));
              return _context.abrupt("return");
            case 4:
              if (!(inputVal.value.length > 0)) {
                _context.next = 13;
                break;
              }
              showLoading(t("Verifying"));
              _context.next = 8;
              return getVoucherCodeDetail({
                card_number: (_inputVal$value = inputVal.value) === null || _inputVal$value === void 0 ? void 0 : _inputVal$value.trim(),
                supplier_id: getSupplyId()
              });
            case 8:
              res = _context.sent;
              if (res.isOK && res.data) {
                if (res.data.is_exists && res.data.status === "activated" && res.data.balance > 0) {
                  Notify.success(t("voucheCodeValid"));
                  emits("verify", res.data);
                } else {
                  Notify.error(t("invalidVoucherCode"));
                  errorText.value = t("invalidVoucherCode");
                }
              }
              hideLoading();
              _context.next = 14;
              break;
            case 13:
              Notify.error(t("plsEnterVoucherCode"));
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _handleVerify.apply(this, arguments);
    }
    function reset() {
      inputVal.value = "";
      errorText.value = "";
    }
    __expose({
      reset: reset
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Input, {
        modelValue: inputVal.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return inputVal.value = $event;
        }),
        class: "voucher-code-input",
        maxlength: "20",
        placeholder: _ctx.$t('enterVoucherCode'),
        "allow-clear": "",
        error: errorText.value
      }, null, 8, ["modelValue", "placeholder", "error"]), _createVNode(Button, {
        class: "redeem-btn absolute-center-y",
        onClick: handleVerify
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("redeem")), 1)];
        }),
        _: 1
      })]);
    };
  }
};